import { mapLinks } from '../../../../../../../utils';
export const bestsellingCollectionsMobile = [
    {
        name: 'Gaming',
        url: '/browse-collections/gaming/bestselling',
        image: 'https://displate.com/img/menu_static/categories/gaming.png',
    },
    {
        name: 'Anime & Manga',
        url: '/browse-collections/anime-and-manga/bestselling',
        image: 'https://displate.com/img/menu_static/categories/anime-and-manga.png',
    },
    {
        name: 'Landscapes',
        url: '/browse-collections/landscapes/bestselling',
        image: 'https://displate.com/img/menu_static/categories/landscapes.png',
    },
    {
        name: 'Nature',
        url: '/browse-collections/nature/bestselling',
        image: 'https://displate.com/img/menu_static/categories/nature.png',
    },
    {
        name: 'Maps',
        url: '/browse-collections/maps/bestselling',
        image: 'https://displate.com/img/menu_static/categories/maps.png',
    },
    {
        name: 'Animals',
        url: '/browse-collections/animals/bestselling',
        image: 'https://displate.com/img/menu_static/categories/animals.png',
    },
    {
        name: 'Space',
        url: '/browse-collections/space/bestselling',
        image: 'https://displate.com/img/menu_static/categories/space.png',
    },
    {
        name: 'Comics',
        url: '/browse-collections/comics/bestselling',
        image: 'https://displate.com/img/menu_static/categories/comics.png',
    },
    {
        name: 'Mancave',
        url: '/browse-collections/mancave/bestselling',
        image: 'https://displate.com/img/menu_static/categories/mancave.png',
    },
];
export const bestsellingCollections = {
    columnTitle: 'Bestselling collections',
    links: mapLinks(bestsellingCollectionsMobile),
};
export const trendingCollectionsMobile = [
    {
        name: 'Fantasy',
        url: '/browse-collections/fantasy/bestselling',
        image: 'https://displate.com/img/menu_static/categories/fantasy.png',
    },
    {
        name: 'Movies',
        url: '/browse-collections/movies/bestselling',
        image: 'https://displate.com/img/menu_static/categories/movies.png',
    },
    {
        name: 'Paintings',
        url: '/browse-collections/paintings/bestselling',
        image: 'https://displate.com/img/menu_static/categories/paintings.png',
    },
    {
        name: 'Japanese & Asian',
        url: '/browse-collections/japanese-and-asian/bestselling',
        image: 'https://displate.com/img/menu_static/categories/japanese-and-asian.png',
    },
    {
        name: 'Vintage posters',
        url: '/browse-collections/vintage-posters/bestselling',
        image: 'https://displate.com/img/menu_static/categories/vintage-posters.png',
    },
    {
        name: 'Celebrities',
        url: '/browse-collections/celebrities/bestselling',
        image: 'https://displate.com/img/menu_static/categories/celebrities.png',
    },
    {
        name: 'Travel',
        url: '/browse-collections/travel/bestselling',
        image: 'https://displate.com/img/menu_static/categories/travel.png',
    },
    {
        name: 'Sport',
        url: '/browse-collections/sport/bestselling',
        image: 'https://displate.com/img/menu_static/categories/sport.png',
    },
    {
        name: 'TV shows',
        url: '/browse-collections/tv-shows/bestselling',
        image: 'https://displate.com/img/menu_static/categories/tv-shows.png',
    },
];
export const trendingCollections = {
    columnTitle: 'New trending collections',
    links: mapLinks(trendingCollectionsMobile),
};
//# sourceMappingURL=collections.js.map